import { ISessionStateService } from "./i-session-state.service";
import { ICompanyRestClient } from "../../rest-clients/company/i-company-rest.client";
import { COMPANY_ROLES, TCompanyRole } from "../../models/company-role";

/** Loads the current user's role in the company into the session, null when it can't be read. */
export async function loadActiveRole( sessionStateService: ISessionStateService, companyRestClient: ICompanyRestClient, companyId: string | null | undefined ): Promise<void> {
	const userId: string | undefined = sessionStateService.getCurrentUser()?.id;
	if ( !companyId || !userId ) {
		sessionStateService.setActiveRole( null );
		return;
	}
	try {
		const role = ( await companyRestClient.getMembers( companyId ) ).find( member => member.userId === userId )?.role;
		sessionStateService.setActiveRole( COMPANY_ROLES.includes( role as TCompanyRole ) ? role as TCompanyRole : null );
	} catch {
		sessionStateService.setActiveRole( null );
	}
}
